<div class="data-section" ngxUiLoaderBlurred [loaderId]="'loader-' + loaderName" [blur]="0" [ngClass]="{'only-graph': hasGraph && !hasTable, 'only-table': hasTable && !hasGraph, 'single-table': hasTable && dashboardData?.tableData?.length == 1, 'is-loading': isLoading }">
    <div class="section-header">
        <h2 class="title">{{ sectionTitle | translate }}</h2>
        @if (filterOptions.length > 0 && !isError && !isLoading) {
            <div class="filter input-group">
                <span class="input-group-text">
                    <i-feather name="filter"></i-feather>
                </span>
                <select class="form-select" [(ngModel)]="filter">
                    @for (option of filterOptions; track option) {
                        <option [value]="option.value">{{option.label}}</option>
                    }
                </select>
            </div>
        }
    </div>
    <div class="content">
        @if (dashboardData && !isError && !isEmpty) {
            @if (hasGraph) {
                <div class="graph">
                    <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions" [legend]="barChartLegend" [type]="barChartType"></canvas>
                </div>
            }
            @if (hasTable) {
                <div class="tables">
                    @for (table of dashboardData.tableData; track table) {
                        <div class="financial-table">
                            <div class="header">
                                <h2>{{ table.isCurrency ? (table.actualMonthValue | currency: 'R$') : (table.actualMonthValue | number: '1.0-2') }}</h2>
                                <span>{{ table.label }}</span>
                            </div>
                            <div class="table-content">
                                    @for (monthData of table.months; track $index; let index = $index) {
                                        <div class="month" [ngClass]="{'best-month': monthData.isBestMonth, 'last-year-month': monthData.isLastYearMonth}">
                                            <div class="best-month-award">
                                                @if (monthData.isBestMonth) {
                                                    <i-feather class="award-icon" name="award"></i-feather>
                                                    <div class="divisor"></div>
                                                }

                                                <span
                                                    class="percentage"
                                                    [ngClass]="{'bether-than-actual-month': monthData.isBetherThanActualMonth, 'actual-month': monthData.isActualMonth, 'with-icon': monthData.isBestMonth }"
                                                    [tooltip]="monthData.isActualMonth ? null : 'support.dashboard.dashboard-data.table.percentage-tooltip.' + (monthData.isBetherThanActualMonth ? 'better-month-than-actual' : 'worse-month-than-actual') | translate: { percentage: (monthData.percentageDifferenceFromActualMonth | number: '1.0-2'), month: monthData.formattedDate }"
                                                    tooltipClass="tooltip-percentage"
                                                >
                                                    @if (monthData.isActualMonth) {
                                                        {{ 'support.dashboard.dashboard-data.table.actual-month' | translate }}
                                                    } @else if (monthData.percentageDifferenceFromActualMonth == 0) {
                                                        -
                                                    } @else{
                                                        <i-feather class="trending-icon" [name]="'trending-' + (monthData.isBetherThanActualMonth ? 'down' : 'up')"></i-feather>

                                                        {{monthData.percentageDifferenceFromActualMonth | number: '1.0-2'}}%
                                                    }
                                                </span>
                                            </div>
                                            <div class="value">
                                                <p>{{ table.isCurrency ? (monthData.value | currency: 'R$') : (monthData.value | number: '1.0-2') }}</p>
                                                <div class="month-data">
                                                    <span>{{ monthData.formattedDate }}</span>
                                                    @if (hasWorkingDaysCount) {
                                                        <span class="working-days"> ({{monthData.workingDaysQuantity}} DU)</span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }
                            </div>
                        </div>
                    }
                </div>
            }
        } @else if (isError) {
            <div class="error-message">
                <p>{{ 'support.dashboard.dashboard-data.error' | translate }}</p>
                <button customButton styleType="secondary" label="elemento.generico-botao.atualizar" [isLoading]="false" (click)="reloadControl()"></button>
            </div>
        } @else if (isEmpty) {
            <div class="empty-message">
                <p>{{ 'support.dashboard.dashboard-data.empty' | translate }}</p>
                <button customButton styleType="secondary" label="elemento.generico-botao.atualizar" [isLoading]="false" (click)="reloadControl()"></button>
            </div>
        }
    </div>
    @if (isLoading) {
        <ngx-ui-loader [loaderId]="'loader-' + loaderName"></ngx-ui-loader>
    }
</div>
